import { DrawingModel, type Handle } from "../DrawingModel";
import type { Chart } from "../../chart/Chart";
import { roundRect } from "./helpers";

export class TextLabel extends DrawingModel {
  type = "text";
  private _w = 40;
  private _h = 20;
  get points() {
    return 1;
  }
  render(ctx: CanvasRenderingContext2D, chart: Chart) {
    const a = this.anchors[0];
    const x = this.X(a, chart);
    const y = this.Y(a, chart);
    const text = this.style.text || "Text";
    const fs = this.style.fontSize || 14;
    ctx.font = `${fs}px -apple-system, system-ui, sans-serif`;
    ctx.textAlign = "left";
    ctx.textBaseline = "top";
    const lines = text.split("\n");
    let maxW = 0;
    for (const l of lines) maxW = Math.max(maxW, ctx.measureText(l).width);
    const pad = 6;
    this._w = maxW + pad * 2;
    this._h = lines.length * (fs + 4) + pad * 2;
    // subtle background
    ctx.fillStyle = "rgba(30,34,45,0.6)";
    roundRect(ctx, x, y, this._w, this._h, 4);
    ctx.fill();
    ctx.fillStyle = this.style.color;
    for (let i = 0; i < lines.length; i++) {
      ctx.fillText(lines[i], x + pad, y + pad + i * (fs + 4));
    }
  }
  handles(chart: Chart): Handle[] {
    const a = this.anchors[0];
    return [{ x: this.X(a, chart), y: this.Y(a, chart), kind: 0 }];
  }
  hitTest(px: number, py: number, chart: Chart) {
    const a = this.anchors[0];
    const x = this.X(a, chart);
    const y = this.Y(a, chart);
    return px >= x && px <= x + this._w && py >= y && py <= y + this._h;
  }
}
